<template>
  <div class="resultCounselor">
    <div class="resultCounselor__title">監修者<br>紹介</div>
    <div class="resultCounselor__who">
      <img class="resultCounselor__image" :src="`${imgPath}counselor${result.counselor.menu_id}.png`" @error="noImage">
      <div class="resultCounselor__box">
        <div class="resultCounselor__name">{{ result.counselor.name }}</div>
        <div class="resultCounselor__text">{{ result.counselor.text }}</div>
      </div>
    </div>
    <div v-if="show" class="resultCounselor__pr">
      <a :href="`${result.counselor.prUrl}`">
        <img class="resultCounselor__prImage" :src="`${imgPath}result/pr${result.counselor.menu_id}.png`" @error="noImage">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "resultCounselor",
  data() {
    return {
      imgPath: '/static/img/yearluck/y2021/',
      show: true,
    }
  },
  props: {
    result: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods : {
    noImage(){
      this.show = false
    }
  },
}
</script>

<style scoped lang="scss">
.resultCounselor {
  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 86px;
    height: 86px;
    margin: 0 auto 26px;
    padding: 6px 0 0 3px;
    background: #412E2E;
    color: #FFE63C;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 1px;
    text-align: center;
    border-radius: 100px;
  }
  &__who {
    overflow: hidden;
    margin: 0 0 32px;
  }
  &__image {
    float: left;
    width: 30.58%;
    max-width: 100px;
    margin: 0 16px 0 0;
    border-radius: 10px;
  }
  &__box {
    overflow: hidden;
    color: #32373F;
  }
  &__name {
    font-weight: bold;
    font-size: 15px;
    line-height: 14px;
  }
  &__text {
    font-size: 12px;
    line-height: 18px;
    text-align: justify;
  }
  &__pr {
  }
  &__prImage {
    display: block;
    with:347px;
    max-width: 100%;
    vertical-align: middle;
    margin: 0　auto 12px;
    filter: drop-shadow(0px 5px 5px rgba(0,0,0,0.3));
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/YearLuck/y2021/resultCounselor.vue